import { inject, Injectable } from '@angular/core';
import { ApiHttpService } from '../../api-http.service';
import { ClientCreditNoteDraftItem, DocumentSections, SupplierCreditNoteItem } from '../../../models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientCreditNoteDraftItemService {
  apiService: ApiHttpService<ClientCreditNoteDraftItem> = inject(ApiHttpService<ClientCreditNoteDraftItem>);

  getForSupplierCreditNote(iri: string): Observable<DocumentSections<ClientCreditNoteDraftItem>> {
    return this.apiService
      .getMany(`${iri}/client_credit_note_draft_items`)
      .pipe(map((result) =>
        ({ [iri]: result.body['hydra:member'] as ClientCreditNoteDraftItem[] })
      ));
  }

  update(iri: string, update: ClientCreditNoteDraftItem): Observable<ClientCreditNoteDraftItem> {
    return this.apiService
      .patch(iri, update)
      .pipe(map((result) => result.body));
  }
}
